import React, { useContext } from 'react'
import { ListGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const PageBreadcrumb = ({ item, main }) => {
  return (
    <ListGroup as="ul" bsPrefix=" " className="breadcrumb">
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to="/">
          <i className="feather icon-home" />
        </Link>
      </ListGroup.Item>
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        {main.title}
      </ListGroup.Item>
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        {item.title}
      </ListGroup.Item>
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        Dashboard
      </ListGroup.Item>
    </ListGroup>
  )
}

export default PageBreadcrumb
